import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { GenerationFootprintBlock } from '../../report/GenerationImpactProjectionBlocks';

/**
 * The parcel and how the promoted fit sits on it.
 *
 * `GenerationComparisonBlock` USED TO RENDER HERE TOO. It was promoted to its
 * own section (`generationScenarioComparison`) so the screening record gets its
 * own table-of-contents line — that section's docstring states the intent
 * plainly: the record should be "a findable part of the document rather than a
 * paragraph inside another section". The call site here was left behind, so a
 * report carrying a comparison printed the SAME seven-column table twice, once
 * under Parcel Overview and again under its own heading.
 *
 * Nothing caught it because the test-fit sample fixture had no comparison data
 * at all, so neither copy rendered. It surfaced the moment the fixture was
 * given a real comparison to exercise the DOCX/PPTX emitters.
 */
export const ParcelOverviewSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const text = report.testFitAnalysis?.siteConstraints;
  const hasPromotedScenario = !!report.generationImpactProjection?.testFitFootprint;
  return (
    <SectionShell label={label} hasData={!!text || hasPromotedScenario}>
      <GenerationFootprintBlock report={report} />
      {text && <p>{text}</p>}
    </SectionShell>
  );
};
